import { render, staticRenderFns } from "./diabetesAssessment.vue?vue&type=template&id=63dc711d&scoped=true"
import script from "./diabetesAssessment.vue?vue&type=script&lang=js"
export * from "./diabetesAssessment.vue?vue&type=script&lang=js"
import style0 from "./diabetesAssessment.vue?vue&type=style&index=0&id=63dc711d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63dc711d",
  null
  
)

export default component.exports